import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import Navigation from "../../../components/navigation";
import SecondScreen from "../../SecondScreen";
import { navigationStep } from "../../../redux/slices/navigation";
import { preloaderToggle } from "../../../redux/slices/preloader";
import StepCustomize from "../../../components/stepCustomize";
import QrTitleField from "../../../components/input/qrTitleField";
import { saveValueMultiUrl } from "../../../redux/slices/saveValue";
import LocationOption from "./LocationOption";
import { resetMultiUrl, setDefaultUrl } from "../../../redux/slices/multiUrl";
import DefaultUrlField from "./DefaultUrlField";
import NumberOfScans from "./NumberOfScans";
import LanguageOption from "./LanguageOption";
import TimeOption from "./TimeOption";
import { useEffect } from "react";
import { handleLink, isNoEditRoute } from "../../../hooks/helpers";
import { ModalSwitchMultiUrlType } from "../../../components";
import {
  FetchMultiUrlData,
  MultiUrlAPI,
  GetQrLink,
} from "../../../redux/requests/multiUrl";
import { setCategory } from "../../../redux/slices/selectCategories";
import Form from "react-bootstrap/Form";
import { SelectCategory } from "../../../components";
import Nav from "react-bootstrap/Nav";
import classnames from "classnames";
import { MAX_LINK_LENGTH } from "../../../constants/inputValues";
import useTypeDecription from "../../../hooks/useTypeDecription";
import useGetDataError from "../../../hooks/useGetDataError";
import useCurrentLocation from "../../../hooks/useCurrentLocation";

export default function MultiUrlPage() {
  const { id } = useParams();
  const { content, getContent } = useTypeDecription();
  const { checkErrorStatus } = useGetDataError();
  const state = useSelector((state) => state);
  const { locations, numberOfScans, languages, times, defaultUrl } =
    state.multiUrl;
  const lang = state.changeLang.language.stepTwo.multiUrl;

  const TYPES_QR = [
    { id: 1, type: lang[27] },
    { id: 2, type: lang[28] },
    { id: 3, type: lang[29] },
    { id: 4, type: lang[30] },
  ];

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { adminEntryLocation } = useCurrentLocation();

  const [qrTitle, setQrTitle] = useState(
    "" || state.saveValue.valueMultiUrl[0]
  );
  const [typeQr, setTypeQr] = useState(
    state.saveValue.valueMultiUrl[1] || TYPES_QR[0].id
  );
  const [validDefaultLink, setValidDefaultLink] = useState(false);
  const [error, setError] = useState(false);
  const [selector, setSelector] = useState(0);
  const [isActiveModal, setIsActiveModal] = useState(false);
  const [disableStep, setDisableStep] = useState(true);

  useEffect(() => {
    getContent("multiurl");
  }, []);

  useEffect(() => {
    if (id || state.getQrLinkSlice.id) {
      dispatch(FetchMultiUrlData(id || state.getQrLinkSlice.id))
        .unwrap()
        .then((data) => {
          setQrTitle(data.qrTitle);
          dispatch(setCategory(data.adsCategories));
        })
        .catch((err) => {
          checkErrorStatus(Number(err.message));
        });
      setValidDefaultLink(true);
    }
  }, [id, state.getQrLinkSlice.id]);

  useEffect(() => {
    if (id && state.saveValue.valueMultiUrl[1] !== 0) {
      setTypeQr(state.saveValue.valueMultiUrl[1]);
    }
  }, [state.saveValue.valueMultiUrl[1]]);

  function step() {
    const generalData = {
      id: id || state.getQrLinkSlice.id,
      typeQr,
      qrTitle,
      defaultUrl,
      category: state.categories.categoryChange,
    };

    if (typeQr === 1) {
      if (disableStep) {
        setError(true);
        return;
      } else {
        setError(false);
        dispatch(
          GetQrLink(() =>
            MultiUrlAPI({
              ...generalData,
              locations: locations.map((item) => {
                return {
                  country_id: item.countryId,
                  city_id: item.cityId || null,
                  locationUrl: item.link,
                  id: item.id,
                };
              }),
            })
          )
        ).then(redirect);
      }
    } else if (typeQr === 2) {
      if (disableStep) {
        setError(true);
        return;
      } else {
        setError(false);
        dispatch(
          GetQrLink(() =>
            MultiUrlAPI({
              ...generalData,
              scans: numberOfScans.map((item) => {
                return {
                  scans: String(item.scanNumber),
                  scansUrl: item.link,
                  id: item.id,
                };
              }),
            })
          )
        ).then(redirect);
      }
    } else if (typeQr === 3) {
      if (disableStep) {
        setError(true);
        return;
      } else {
        setError(false);
        dispatch(
          GetQrLink(() =>
            MultiUrlAPI({
              ...generalData,
              times: times.map((item) => {
                return {
                  timezone_id: item.timezoneId,
                  timeUrl: item.link,
                  start_time: item.startTime,
                  end_time: item.endTime,
                  id: item.id,
                };
              }),
            })
          )
        ).then(redirect);
      }
    } else if (typeQr === 4) {
      if (disableStep) {
        setError(true);
        return;
      } else {
        setError(false);
        dispatch(
          GetQrLink(() =>
            MultiUrlAPI({
              ...generalData,
              languages: languages.map((item) => {
                return {
                  language: item.languageId,
                  languageUrl: item.link,
                  id: item.id,
                };
              }),
            })
          )
        ).then(redirect);
      }
    }
    dispatch(preloaderToggle(true));
  }

  useEffect(() => {
    if (
      state.getQrLinkSlice.status === "success" &&
      !!state.getQrLinkSlice.link &&
      state.preloader.toggle
    ) {
      if (isNoEditRoute) {
        navigate("/qr");
        dispatch(navigationStep(3));
        dispatch(saveValueMultiUrl([qrTitle, typeQr]));
      }
    } else if (state.getQrLinkSlice.status === "failed") {
      dispatch(preloaderToggle(false));
    }
  }, [state.getQrLinkSlice.status]);

  useEffect(() => {
    if (state.getQrLinkSlice.id) {
      handleLink(state.multiUrl.defaultUrl, setValidDefaultLink, (link) =>
        dispatch(setDefaultUrl(link))
      );
    }
  }, [state.getQrLinkSlice.id]);

  const redirect = () => {
    if (!isNoEditRoute) {
      window.location.href = adminEntryLocation;
    }
  };
  const handleSelect = (value) => {
    const id = Number(value);
    if (typeQr > 0) {
      setIsActiveModal(true);
      setSelector(id);
      return;
    }
    setTypeQr(id);
    setError(false);
  };

  const handleModal = (isSwitch) => {
    setIsActiveModal(false);
    if (isSwitch) {
      setTypeQr(selector);
      setError(false);
      dispatch(resetMultiUrl());
    }
  };

  const stepValidate = () => {
    if (typeQr === 1)
      setDisableStep(
        locations.some(
          ({ countryId, linkValid, link }) =>
            !countryId || !linkValid || link.length > MAX_LINK_LENGTH
        ) ||
          !validDefaultLink ||
          defaultUrl.length > MAX_LINK_LENGTH
      );
    if (typeQr === 2)
      setDisableStep(
        numberOfScans.some(
          ({ scanNumber, linkValid, link }) =>
            scanNumber < 0 || !linkValid || link.length > MAX_LINK_LENGTH
        ) ||
          !validDefaultLink ||
          defaultUrl.length > MAX_LINK_LENGTH
      );
    if (typeQr === 3)
      setDisableStep(
        times.some(
          ({ linkValid, timezoneId, startTime, endTime, link }) =>
            !timezoneId ||
            !linkValid ||
            !startTime ||
            !endTime ||
            link.length > MAX_LINK_LENGTH
        ) ||
          !validDefaultLink ||
          defaultUrl.length > MAX_LINK_LENGTH
      );
    if (typeQr === 4)
      setDisableStep(
        languages.some(
          ({ languageId, linkValid, link }) =>
            !languageId || !linkValid || link.length > MAX_LINK_LENGTH
        ) ||
          !validDefaultLink ||
          defaultUrl.length > MAX_LINK_LENGTH
      );
  };

  useEffect(() => {
    stepValidate();
  }, [state]);

  return (
    <>
      {isActiveModal && (
        <ModalSwitchMultiUrlType isActive={true} handleModal={handleModal} />
      )}
      <Navigation />
      <SecondScreen>
        <Form className="col-12 col-lg-6 mx-auto">
          <Nav
            activeKey={TYPES_QR[0].id}
            onSelect={(eventKey) => handleSelect(eventKey)}
            className="flex flex-nowrap mb-4 border-bottom border-border-gray"
          >
            {TYPES_QR.map((item) => (
              <Nav.Item
                key={item.id}
                className={classnames("w-100", {
                  active_bottom: item.id === typeQr,
                })}
              >
                <Nav.Link
                  eventKey={item.id}
                  className={classnames("d-flex justify-content-center", {
                    "fw-bold text-secondary": item.id === typeQr,
                    "text-dark": item.id !== typeQr,
                  })}
                >
                  {item.type}
                </Nav.Link>
              </Nav.Item>
            ))}
          </Nav>
          <DefaultUrlField
            validLink={validDefaultLink}
            setValidLink={setValidDefaultLink}
            error={error}
          />
          {typeQr === 1 && <LocationOption error={error} />}
          {typeQr === 2 && <NumberOfScans error={error} />}
          {typeQr === 3 && <TimeOption error={error} />}
          {typeQr === 4 && <LanguageOption error={error} />}

          <QrTitleField
            value={qrTitle}
            onChange={(e) => setQrTitle(e.target.value)}
          />
        </Form>
        <SelectCategory />
        <StepCustomize emulate={step} disabled={disableStep} />
      </SecondScreen>
      {isNoEditRoute && content}
    </>
  );
}
